<template>
  <div class="container-fluid">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Ver Servicio</h1>
    </div>
    <small v-if="servicio">Los datos se refrescan cada 5 segundos, última comsulta: {{ ultimaConsulta.format('Y-M-D HH:mm:ss') }}</small>
    <div class="card" v-if="servicio">
      <div class="card-header">
        Historial de eventos
        <b-form-select v-model="limitTo" :options="cantidadesVisualizacion" class="float-right" style="max-width: 150px;"></b-form-select>
      </div>
      <ul class="list-group">
        <div class="card-body">
          <p>
            {{ servicio.nombre}}<br>
            Dirección: {{ servicio.direccion}}<br>
            Localidad: {{servicio.localidad}}<br>
            <span v-if="info">
              Ultimo Evento Recibido: {{ info.ultimo_evento }}<br>
              <strong>Ultimo Autotest Recibido:</strong> {{ info.ultimo_autotest }}
            </span>
          </p>
        </div>
        <li v-for="evento in eventos" :key="evento.id" class="list-group-item">
          {{ evento.nombre }} - {{evento.fecha}}
        </li>
        <li v-if="eventos.length == 0" class="list-group-item">No tienes eventos</li>
      </ul>
    </div>
    
  </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert2'
export default {
  middleware: 'auth',
  layout: 'main-layout',
  metaInfo () {
    return { title: 'Ver Servicio de Monitoreo' }
  },
  data: () => ({
    limitTo: 5,
    servicio: null,
    eventos: [],
    info: null,
    timer: null,
    password: null,
    allowed: false,
    ultimaConsulta: null,
    cantidadesVisualizacion: [
      {value:5, text:'Mostrar 5'},
      {value:10, text:'Mostrar 10'}, 
      {value:20, text:'Mostrar 20'}, 
      {value:50, text:'Mostrar 50'}, 
      {value:100, text:'Mostrar 100'}
    ]
  }),
  mounted () {
    this.ultimaConsulta = this.$moment()
    if(!this.servicio){
      this.askPalabraClave()
    }
    // this.startInterval()
  },
  methods: {
    async askPalabraClave(){
      const { data: { data } } = await axios.get(`/samm/clientes/${this.$route.params.id}`)
      this.servicio = data
      const { value: password } = await swal.fire({
        title: 'Ingrese palabra clave del servicio',
        input: 'password',
        footer: 'Servicio: ' + data.nombre + '<br>Dirección: ' + data.direccion + ', ' + data.localidad,
        inputPlaceholder: 'Palabra Clave',
        inputAttributes: {
          maxlength: 30,
          autocapitalize: 'off',
          autocorrect: 'off'
        }
      })
      if (password) {
        //swal.fire(`Entered password: ${password}`)
        this.checkClave (password)
      }
    },
    startInterval () {
      this.checkEventos()
      this.timer = window.setInterval(()=> {this.checkEventos()}, 5000)
    },
    async checkEventos (){
      const { data: { data, info } } = await axios.post(`/samm/log/${this.$route.params.id}`, {password: this.password })
      this.ultimaConsulta = this.$moment()
      this.info = info
      this.eventos = data.slice(0,this.limitTo).filter(item => item.tipo != 'E602')
    },
    async checkClave (str){
      const { data } = await axios.post(`/samm/check-password/${this.$route.params.id}`, {password: str })
      if(data.status === 'ok'){
        swal.fire(`La palabra clave es correcta`)
        this.password = str
        this.checkEventos ()
        this.startInterval()
      } else {
        await swal.fire(`La palabra clave es incorrecta`)
        this.askPalabraClave()
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    window.clearInterval(this.timer)
    next()
  }
}
</script>
